// utils/cookies.js

/**
 * Obtiene el valor de una cookie por nombre.
 * - Devuelve null en SSR (no hay document) o si no existe.
 * - Decodifica con decodeURIComponent de forma segura.
 *
 * @param {string} name
 * @returns {string|null}
 */
export function getCookie(name) {
  if (!name) return null;
  if (typeof document === "undefined" || typeof document.cookie !== "string") return null;

  // Escapa caracteres especiales del nombre para construir el RegExp
  const escapedName = name.replace(/[.*+?^${}()|[\]\\\/]/g, "\\$&");
  const pattern = new RegExp("(?:^|; )" + escapedName + "=([^;]*)");

  const matches = document.cookie.match(pattern);
  if (!matches) return null;

  try {
    return decodeURIComponent(matches[1]);
  } catch {
    // Por si el valor no está URI-encoded
    return matches[1];
  }
}
